import { useToastsHook, useTranslation } from '@bcba/react-hooks';
import { Modal, Flex, FiAlertTriangle, Text } from '@agrotoken-tech/ui';
import { useMutation } from '@tanstack/react-query';
import { creditorApproveCropPledge } from '../../../../services/crop-pledge';
import { useCropPledgeContext } from '../context/CropPledgeContext';
import { useParams } from 'react-router-dom';
import { CURRENCIES } from '@bcba/types';

interface ApproveCropPledgeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ApproveCropPledgeModal = ({
  isOpen,
  onClose,
}: ApproveCropPledgeModalProps) => {
  const { t } = useTranslation();
  const params = useParams();
  const cropPledgeUuid = params['uuid'] || '';
  const { showSuccessToast } = useToastsHook();

  const { totalEstimatedProductionValueInUsd, refetchCropPledgeStatus } =
    useCropPledgeContext();

  const {
    mutate: onCreditorApproveCropPledge,
    isPending: isLoadingCreditorApproval,
  } = useMutation({
    mutationFn: () => creditorApproveCropPledge(cropPledgeUuid),
    onSuccess: () => {
      refetchCropPledgeStatus();
      showSuccessToast({ title: t('cropPledge.approve.toast.success') });
      onClose();
    },
  });

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      title={t('cropPledge.actions.approve.modal.title')}
      isLoadingConfirmBtn={isLoadingCreditorApproval}
      labelBtnConfirm={t('cropPledge.actions.approve.modal.confirmLabel')}
      variantBtnConfirm="primary"
      labelBtnClose={t('common.cancel')}
      onClickConfirm={onCreditorApproveCropPledge}
      iconVariant="primary"
      icon={FiAlertTriangle}
    >
      <Flex>
        <Text>
          {t('cropPledge.actions.approve.modal.text')
            .replace('{{currency}}', CURRENCIES.USD)
            .replace(
              '{{amount}}',
              Number(totalEstimatedProductionValueInUsd).toLocaleString(
                'es-AR',
              ),
            )}
        </Text>
      </Flex>
    </Modal>
  );
};
